import {IPageAndSort, IPagination} from '@entities/api';
import {IListSubject} from '@entities/subject';
import {createAction, props} from '@ngrx/store';
import {
  getActionDescription,
  getApiActionsWithPayload,
} from '@binotel-frontend/bnt-common-components';

const desc = getActionDescription('Search');

export namespace SearchActions {
  export const searchSubjects = getApiActionsWithPayload(
    desc('Get subjects'),
    props<{query: string; pagination?: IPageAndSort}>(),
    props<{payload: IListSubject[]; pagination: IPagination}>()
  );

  export const clearSubjects = createAction(desc('Clear Subjects'));
  export const clearSearch = createAction(desc('Clear Search'));
}
